import "../Styles/Login.css"
import { useRef, useState, useEffect} from 'react';
import {useNavigate } from 'react-router-dom';

import axios from '../Api/axios';
import FormData from 'form-data';

import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Card from '@mui/material/Card';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Avatar from '@mui/material/Avatar';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import TextField from '@mui/material/TextField';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import OutlinedInput from '@mui/material/OutlinedInput';
import Button from '@mui/material/Button';
import Done from '@mui/icons-material/Done';
import Close from '@mui/icons-material/Close';
import CircularProgress from '@mui/material/CircularProgress';



const CREATE_ACC_ENDPOINT = "auth/account"

export const CreateAccount = () => {

    const accountNameRef = useRef();
    const displayNameRef = useRef();
    const emailRef = useRef();

    const navigate = useNavigate();

    const [messageType, setMessageType] = useState('');
    const [message, setMessage] = useState('');
    const [loading, setLoading] = useState(false);

    const [accountName, setAccountName] = useState('');
    const [displayName, setDisplayName] = useState('');
    const [pwd, setPwd] = useState('');
    const [confirmPwd, setConfirmPwd] = useState('');
    const [email, setEmail] = useState('');
    const [refcode, setRefcode] = useState('');

    const setErrMsg = (msg) => {
      setMessage(msg);
      setMessageType("error");
    }

    const [showPassword, setShowPassword] = useState(false);
    const handleClickShowPassword = () => setShowPassword((show) => !show);
    const handleMouseDownPassword = (event) => {
      event.preventDefault();
    };

    useEffect(() => {
      accountNameRef.current.focus();
    }, [])

    useEffect(() => {
        setErrMsg('');
    }, [accountName, pwd, confirmPwd, displayName, email])

    const handleSubmit = async (e) => {
      e.preventDefault();
      setErrMsg('');
      try {
          var form = new FormData()
          var redirectUrl = window.location.protocol + "//" + window.location.host + "/landing?action=email";
          form.append('AccountName', accountName);
          form.append('Password', pwd);
          form.append('ConfirmPassword', confirmPwd);
          form.append('Email', email);
          if (refcode?.length > 0)
            form.append('Refcode', refcode);
          form.append('DisplayName', displayName);
          form.append('RedirectUrl', redirectUrl);
          setLoading(true);
          const response = await axios.post(CREATE_ACC_ENDPOINT,
            form,
            {
              withCredentials: true
            });
          setLoading(false);
          navigate('/login', {
            replace:true, state:{
              message:'Succeed! Confirmation email has been sent. You may now log in.',
              messageType:'success'
            }});
      } catch (err) {
        setLoading(false);
          if (!err?.response) {
              setErrMsg('Server is not responding. Try again later.');
          } else if (err.response?.status === 429) {
              setErrMsg('Woah! Slow down. Try again in a few minutes.');
          } else {
            const errorCode = err?.response?.data?.code
            switch(errorCode){
              case 1: // ACCOUNT NAME LENGTH EXCEEDED
                setErrMsg('Account name length limit exceeded.');
                break;
              case 2: // ACCOUNT NAME ILLEGAL CHARACTERS
                setErrMsg("Account name contains illegal characters.");
                break;
              case 3: // PASSWORD TOO SHORT
                setErrMsg("Password is too short.");
                break;
              case 4: // PASSWORD LENGTH LIMIT EXCEEDED
                setErrMsg("Password length limit exceeded.");
                break;
              case 5: // PASSWORD
                setErrMsg("Password contains illegal characters.");
                break;
              case 6: // DISPLAY NAME LENGTH EXCEEDED
                setErrMsg('Display name length limit exceeded.');
                break;
              case 7: // DISPLAY NAME ILLEGAL CHARACTERS
                setErrMsg("Display name contains illegal characters.");
                break;
              case 8: // DISPLAY NAME SHORT WORDS
                setErrMsg("Display name contains too short words.");
                break;
              case 9: // DISPLAY NAME ILLEGAL WORDS
                setErrMsg("Display name contains illegal words.");
                break;
              case 10: // EMAIL LENGTH EXCEEDED
                setErrMsg("Email length limits exceeded.");
                break;
              case 11: // WRONG EMAIL FORMAT
                setErrMsg("Wrong email format.");
                break;
              case 13: // CONFIRM PASSWORD DOESNT MATCH
                setErrMsg("Confirm password doesn't match.");
                break;
              case 14: // WRONG REF CODE
                setErrMsg("Wrong referral code.");
                break;
              case 15: // REF CODE DISABLED
                setErrMsg("Referral code is disabled.");
                break;
              case 16: // REF CODE ACCOUNT DOESNT EXIST
                setErrMsg("Referral code account doesn't exist.");
                break;
              default:
                setErrMsg('Unknown error has occured. Try again later.');
                break;
            }
          }
      }
  }

  return (
    <Container component="main" maxWidth="xs">
        <Box 
        component="form"
        onSubmit={handleSubmit}
        sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyItems: 'center'
        }}>
            <Paper elevation={16}
                sx={{
                    borderRadius: 10,
                }}>
                <Typography
                    variant="h4"
                    margin="15px"
                    color="white" 
                    textAlign="center">Create Account</Typography>
                    <Stack orientation="vertical" paddingX="20px">
                        <TextField variant="outlined"
                            required
                            id="accountNameField"
                            label="Account Name"
                            autoComplete="off"
                            color="primary"
                            value={accountName}
                            ref={accountNameRef}
                            onInput={e=>setAccountName(e.target.value)} 
                            sx={{
                                marginBottom: '15px',
                                input:{color:'white', textAlign:'left'}
                            }}/>
                        <TextField variant="outlined"
                            required
                            id="displayNameField"
                            label="Display Name"
                            autoComplete="off"
                            color="primary"
                            value={displayName}
                            ref={displayNameRef}
                            onInput={e=>setDisplayName(e.target.value)} 
                            sx={{
                                marginBottom: '15px',
                                input:{color:'white', textAlign:'left'}
                            }}/>
                        <TextField 
                            required
                            variant="outlined"
                            id="passwordField"
                            autoComplete="off"
                            label="Password"
                            color="primary"
                            value={pwd}
                            onInput={e=>setPwd(e.target.value)} 
                            sx={{
                                marginBottom: '15px',
                                input:{color:'white', textAlign:'left'}
                            }}
                            type={showPassword ? 'text' : 'password'}
                            InputProps={{
                              endAdornment: <InputAdornment position="end">
                                <IconButton
                                  aria-label="toggle password visibility"
                                  onClick={handleClickShowPassword}
                                  onMouseDown={handleMouseDownPassword}
                                  edge="end"
                                >
                                  {showPassword ? <VisibilityOff sx={{color:'white'}}/> : <Visibility sx={{color:'white'}}/>}
                                </IconButton>
                              </InputAdornment>
                            }}/>
                        <TextField 
                            required
                            variant="outlined"
                            id="confirmPasswordField"
                            autoComplete="off"
                            label="Confirm Password"
                            color="primary"
                            value={confirmPwd}
                            onInput={e=>setConfirmPwd(e.target.value)} 
                            sx={{
                                marginBottom: '15px',
                                input:{color:'white', textAlign:'left'}
                            }}
                            type={showPassword ? 'text' : 'password'}/>
                        <TextField variant="outlined"
                            required
                            id="emailField"
                            label="Email"
                            autoComplete="off"
                            color="primary"
                            value={email}
                            ref={emailRef}
                            onInput={e=>setEmail(e.target.value)} 
                            sx={{
                                marginBottom: '15px',
                                input:{color:'white', textAlign:'left'}
                            }}/>
                        <TextField variant="outlined"
                            id="refField"
                            label="Referral Code"
                            autoComplete="off"
                            color="primary"
                            value={refcode}
                            onInput={e=>setRefcode(e.target.value)} 
                            sx={{
                                marginBottom: '15px',
                                input:{color:'white', textAlign:'left'}
                            }}/>
                    </Stack>
                    <Stack alignItems="center">
                      <Button variant="contained" type="submit" sx={{minWidth:'200px', marginBottom:'10px'}}>CREATE ACCOUNT</Button>
                      <Button sx={{minWidth:'200px', marginBottom:'15px'}} onClick={()=> {
                        navigate('/login')
                      }}>Log in to an existing account</Button>
                      {loading ? <CircularProgress sx={{width:'32px', marginBottom:'10px'}}/> : null}
                      {message?.length > 0 ?
                      <Grid container orientation="row" justifyContent="center" sx={{marginBottom:'10px'}}>
                          <Grid item xs="auto"> 
                            {messageType === "error" ? <Close color='error'/> : <Done color='info'/>}
                          </Grid>
                          <Grid item xs="auto">
                            <Typography variant="h7" color={messageType === 'error' ? 'error' : 'info'}>
                              {message}
                            </Typography>
                          </Grid>
                      </Grid>
                       : null}
                    </Stack>
            </Paper>
        </Box>
    </Container>
  )
}
